import type { Avatar } from '../../../types'

// Profile pictures state
export const SET_COMMUNITY_PROFILE_PICTURES = 'SET_COMMUNITY_PROFILE_PICTURES'
export const SET_COMMUNITY_PROFILE_PICTURES_PROCESSING = 'SET_COMMUNITY_PROFILE_PICTURES_PROCESSING'
export const SET_COMMUNITY_PROFILE_PICTURES_ERROR = 'SET_COMMUNITY_PROFILE_PICTURES_ERROR'

// Profile pictures watcher trigger
export const COMMUNITY_PROFILE_FETCH_PROFILE_PICTURES = 'COMMUNITY_PROFILE_FETCH_PROFILE_PICTURES'

// Avatar upload state
export const SET_COMMUNITY_PROFILE_AVATAR_UPLOAD_PROCESSING = 'SET_COMMUNITY_PROFILE_AVATAR_UPLOAD_PROCESSING'
export const SET_COMMUNITY_PROFILE_AVATAR_UPLOAD_SUCCESS = 'SET_COMMUNITY_PROFILE_AVATAR_UPLOAD_SUCCESS'
export const SET_COMMUNITY_PROFILE_AVATAR_UPLOAD_ERROR = 'SET_COMMUNITY_PROFILE_AVATAR_UPLOAD_ERROR'

// Avatar delete state
export const SET_COMMUNITY_PROFILE_AVATAR_DELETE_PROCESSING = 'SET_COMMUNITY_PROFILE_AVATAR_DELETE_PROCESSING'
export const SET_COMMUNITY_PROFILE_AVATAR_DELETE_SUCCESS = 'SET_COMMUNITY_PROFILE_AVATAR_DELETE_SUCCESS'
export const SET_COMMUNITY_PROFILE_AVATAR_DELETE_ERROR = 'SET_COMMUNITY_PROFILE_AVATAR_DELETE_ERROR'

// Avatar watcher triggers
export const COMMUNITY_PROFILE_UPLOAD_AVATAR = 'COMMUNITY_PROFILE_UPLOAD_AVATAR'
export const COMMUNITY_PROFILE_DELETE_AVATAR = 'COMMUNITY_PROFILE_DELETE_AVATAR'

// ── Watcher-trigger action creators ──────────────────────────────────

export function uploadAvatar ({ imageBlob, fileExtension }: {
  imageBlob: Blob
  fileExtension: string
}) {
  return {
    type: COMMUNITY_PROFILE_UPLOAD_AVATAR,
    payload: { imageBlob, fileExtension },
  } as const
}

export function deleteAvatar () {
  return {
    type: COMMUNITY_PROFILE_DELETE_AVATAR,
  } as const
}

export function fetchProfilePictures (uids: Array<number | string>) {
  return {
    type: COMMUNITY_PROFILE_FETCH_PROFILE_PICTURES,
    payload: { uids },
  } as const
}

// ── SET_* action creators (used by watchers) ─────────────────────────

export function setAvatarUploadProcessing (processing: boolean) {
  return {
    type: SET_COMMUNITY_PROFILE_AVATAR_UPLOAD_PROCESSING,
    payload: processing,
  } as const
}

export function setAvatarUploadSuccess () {
  return {
    type: SET_COMMUNITY_PROFILE_AVATAR_UPLOAD_SUCCESS,
  } as const
}

export function setAvatarUploadError (error: string) {
  return {
    type: SET_COMMUNITY_PROFILE_AVATAR_UPLOAD_ERROR,
    payload: error,
  } as const
}

export function setAvatarDeleteProcessing (processing: boolean) {
  return {
    type: SET_COMMUNITY_PROFILE_AVATAR_DELETE_PROCESSING,
    payload: processing,
  } as const
}

export function setAvatarDeleteSuccess () {
  return {
    type: SET_COMMUNITY_PROFILE_AVATAR_DELETE_SUCCESS,
  } as const
}

export function setAvatarDeleteError (error: string) {
  return {
    type: SET_COMMUNITY_PROFILE_AVATAR_DELETE_ERROR,
    payload: error,
  } as const
}

/**
 * Store avatars, optionally with the Community display name for the same uid.
 *
 * `displayName` rides along rather than living in its own slice: the two are fetched by the same
 * query, for the same uid, and are always rendered together (avatar + name). A parallel map would
 * be a second thing to keep in sync for no gain. Existing readers that only do
 * `getIn([uid, 'card'])` are unaffected.
 */
export function setProfilePictures (
  payload: Record<string, Avatar & { displayName?: string | null }>,
) {
  return {
    type: SET_COMMUNITY_PROFILE_PICTURES,
    payload,
  } as const
}

export function setProfilePicturesProcessing (processing: boolean) {
  return {
    type: SET_COMMUNITY_PROFILE_PICTURES_PROCESSING,
    payload: processing,
  } as const
}

export function setProfilePicturesError (error: string) {
  return {
    type: SET_COMMUNITY_PROFILE_PICTURES_ERROR,
    payload: error,
  } as const
}
